import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get_showcase_order_detail, start_showcase_order, showcase_delivery, showcase_delivery_approval, showcase_revision, mark_missing_details } from '../../Apis';


export const GetShowCaseOrder = createAsyncThunk('GetShowCaseOrder', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await get_showcase_order_detail(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


export const StartOrder = createAsyncThunk('StartOrder', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await start_showcase_order(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const MissingDetails = createAsyncThunk('mark_missing_details', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await mark_missing_details(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const MarkShowcaseDelivery = createAsyncThunk('MarkShowcaseDelivery', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await showcase_delivery(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const ApproveShowcaseDelivery = createAsyncThunk('ApproveShowcaseDelivery', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await showcase_delivery_approval(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const CreateShowcaseRevision = createAsyncThunk('CreateShowcaseRevision', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await showcase_revision(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


const showcaseOrderSlice = createSlice({
    name: 'showOrder',
    initialState: {
        error: null,
        success: false,
        error1: null,
        success1: false,
        data: {},

    },
    reducers: {
        clearShowOrderStatus: state => {
            state.success = false;
            state.error = null;
            state.success1 = false;
            state.error1 = null;
        }
    },
    extraReducers: builder => {
        builder
            // gett
            .addCase(GetShowCaseOrder.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetShowCaseOrder.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(GetShowCaseOrder.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(StartOrder.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(StartOrder.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(StartOrder.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })

            .addCase(MarkShowcaseDelivery.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(MarkShowcaseDelivery.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(MarkShowcaseDelivery.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
            .addCase(ApproveShowcaseDelivery.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(ApproveShowcaseDelivery.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(ApproveShowcaseDelivery.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
            .addCase(CreateShowcaseRevision.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(CreateShowcaseRevision.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(CreateShowcaseRevision.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
    },

});
export const { clearShowOrderStatus } = showcaseOrderSlice.actions;
export default showcaseOrderSlice.reducer;

